<template>
  <BaseTab id="parkingLot">
    <v-subheader>PARKING LOT</v-subheader>
    <div />
    <v-textarea
      v-model="addHMWText"
      class="mx-auto add-hmw-field"
      placeholder="Add a HMW then press enter..."
      @keydown.enter="handleAddHMW"
      rounded
      filled
      flat
      auto-grow
      rows=2
      :disabled="currentlyViewedChallenge.archived"
    />
    <v-list two-line>
      <template v-for="(HMW, i) in HMWs">
        <HMW
          :key="i"
          :HMW="HMW"
        />
      </template>
    </v-list>
  </BaseTab>
</template>

<script>
import BaseTab from '@/components/base/BaseTab'
import HMW from '@/views/whiteboard/drawer/parkingLot/HMW'
import interact from 'interactjs'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'ParkingLot',

  data: () => ({
    addHMWText: '',
    windowHeight: window.innerHeight
  }),

  components: {
    BaseTab,
    HMW
  },

  async created () {
    await this.requestAllHMWs()
  },

  mounted () {
    interact('#parkingLot').dropzone({})
  },

  computed: {
    ...mapState({
      HMWs: state => state.canvas.HMW.HMWs,
      currentlyViewedChallenge: state => state.challenge.currentlyViewedChallenge
    })
  },

  methods: {
    // ...mapActions(['sendNotificationMessage']),
    ...mapActions('canvas', [
      'requestAllHMWs',
      'requestCreateHMW'
    ]),

    handleAddHMW () {
      if (this.addHMWText !== '') {
        const HMWLines = this.addHMWText.split('\n').filter(h => h !== '')
        console.log(HMWLines)
        for (const h of HMWLines) {
          // trim leading + trailing whitespace, always end with question
          const hmwText = h.trim()
          this.requestCreateHMW(hmwText)
        }
        this.addHMWText = ''
      }
    }
  }
}
</script>

<style lang="sass" scoped>
  #parking-lot
    z-index: 1

  .add-hmw-field
    width: 250px
    top: 1em
    color: black !important
</style>
